<template>
  <v-container :class="{'fill-height': !hasMessage}">
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="6">
        <v-form @submit.prevent="submit"
                :disabled="form.busy"
                autocomplete="off"
                ref="form">
          <v-card tile
                  class="mb-4">
            <v-card-title class="d-flex flex-column text-uppercase align-center justify-center">
              <v-img src="/v2/images/mobilelocker_logo.png"
                     alt="Mobile Locker">
              </v-img>
            </v-card-title>
            <v-progress-linear indeterminate
                               v-if="form.busy">
            </v-progress-linear>
            <v-card-text class="pb-0">

              <v-text-field v-model="form.code"
                            type="text"
                            pattern="[0-9]*"
                            label="Enter the 6-digit code generated by your authentication app."
                            placeholder="123456"
                            autocomplete="one-time-code"
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('code')">
              </v-text-field>

              <div v-if="error"
                   class="red--text">
                {{ error }}
              </div>
            </v-card-text>
            <v-card-actions class="d-flex flex-column">
              <v-btn type="submit"
                     :disabled="form.busy || !form.code || form.code.length < 6"
                     block
                     color="primary">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>

          <div class="text-center">
            <p>
              <router-link :to="{name: 'login.tfa.recovery_code'}">
                Use a recovery code
              </router-link>
            </p>

            <p>
              <a href="/logout"
                 @click.prevent="logout">
                Log in as a different user
              </a>
            </p>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import axios from '../../services/axiosService';
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';

export default {
  mixins: [formValidation],
  metaInfo() {
    this.$store.commit('setTitle', `Log in`);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      error: null,
      form: new Form({
        code: '',
      }),
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'user',
    ]),
    hasMessage() {
      return !!this.message;
    },
  },
  created() {
    this.initLogin();
  },
  methods: {
    async initLogin() {
      await axios.get('/spark/token')
        .catch(() => {
        });
      await this.$store.dispatch('fetchUser')
        .catch(() => {});
    },
    logout() {
      this.$store.dispatch('logout');
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      if (!this.form.code || this.form.code.length < 6) {
        this.error = 'Enter your 6-digit code';
        return;
      }
      this.error = null;
      this.form.post(`/login/tfa`)
        .then(({data}) => {
          const target = data && data.redirect_to ? data.redirect_to : '/admin/account';
          window.location.assign(target);
          //this.$router.push(target);
          this.form.finishProcessing();
        })
        .catch(err => {
          this.error = err.response.data.error
        })
    }
  }
}
</script>
